import styled from "@emotion/styled";
import { UploadedMediaData } from "./types";
import { useConfig } from "@kaltura/mediaspace-shared-data-kms-config";
import { formatters, translate, useTranslateTime } from "@kaltura/mediaspace-shared-utils";
import { Stack } from "@kaltura/mediaspace-shared-styled";
import { Typography } from "@kaltura/ds-react-components";

interface VideoSourceMetadataProps {
    data: UploadedMediaData;
}

/**
 * Component that displays metadata of the selected simulive video source.
 */
export const VideoSourceMetadata = ({ data: { name, updatedAt, duration } }: VideoSourceMetadataProps) => {
    const config = useConfig();
    const formattedTimestamp = useTranslateTime(updatedAt, config.application.dateFormats.shortDate);

    return (
        <Stack direction={"column"} gap={1}>
            <Typography variant={"body1Highlight"}>{name}</Typography>

            <StyledSecondaryMetadata variant={"body2Highlight"}>
                {translate("Last updated at %1", [formattedTimestamp])}
            </StyledSecondaryMetadata>

            {!!duration && (
                <StyledSecondaryMetadata variant={"body2Highlight"}>
                    {translate("Duration")}: {formatters.formatSecondsToTime(duration)}
                </StyledSecondaryMetadata>
            )}
        </Stack>
    );
};

const StyledSecondaryMetadata = styled(Typography)(({ theme }) => ({
    color: theme.kaltura.palette.tone2,
}));
